import {
  FaSpotify,
  FaGithub,
  FaVoteYea,
  FaLayerGroup,
  FaHashtag,
} from "react-icons/fa";

export const ProjectsData = [
  {
    title: "Spotify Stats",
    blurb:
      "Shows what I'm playing right now, plus my most-played tracks and artists. It pulls straight from the Spotify API.",
    href: "/projects/spotify",
    internal: true,
    tag: "Live data",
    icon: FaSpotify,
    accent: "#1db954",
  },
  {
    title: "Tic Tac Toe",
    blurb:
      "Play against the minimax algorithm I wrote in C++, ported to run in the browser. It searches the whole game tree, so it doesn't lose.",
    href: "/projects/tictactoe",
    internal: true,
    tag: "Game",
    icon: FaHashtag,
    accent: "#f59e0b",
  },
  {
    title: "Votify",
    blurb:
      "Vote on what plays next. Everyone joins a session, nominates tracks, and the winners drop into the host's Spotify queue.",
    href: "/projects/votify",
    internal: true,
    tag: "Web app",
    icon: FaVoteYea,
    accent: "#4f46e5",
  },
  {
    title: "Anim",
    blurb:
      "A venture I'm part of. Head over to see what we're working on.",
    href: "https://anim.llc/",
    internal: false,
    tag: "Venture",
    icon: FaLayerGroup,
    accent: "#7c3aed",
  },
  {
    title: "GitHub",
    blurb:
      "Where the rest of my code lives, including the source for this site.",
    href: "https://github.com/pattisonb/",
    internal: false,
    tag: "Open source",
    icon: FaGithub,
    accent: "#64748b",
  },
];
